import React from 'react'
import DynamicForm from '../../../../../components/FormElements/DynamicForm'
import ReviewContent from '../ReviewContent'
import * as Yup from 'yup'
import Button from '../../../../../components/FormElements/Button'

const AddReviewResponse = ({ data, response }) => {

    const form = {
        name: 'reviewResponseForm',
        formFields: [
            {
                name: 'reply',
                type: 'textarea',
                label: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                placeholder: 'Write your reply',
                classes: '',
                icon: null
            },
        ],
        formValidation: {
            reply: Yup.string().
                min(2).
                max(500).
                required('Reply is required')
        }
    }

    const submitForm = () => {
        document.querySelector('form#reviewResponseForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const handleSubmit = (values) => {
        const { reply } = values

        response(reply)
    };

    return (
        <React.Fragment>
            {data && (
                <div className='flex flex-col items-start p-5 w-full '>
                    <div className='mb-2'>
                        <ReviewContent data={data} />
                    </div>
                    <h6 className='heading-6 font-semibold text-sm'>Review Reply</h6>
                    <DynamicForm id="reviewResponseForm" onSubmit={handleSubmit} form={form} />
                    <div className="flex justify-end w-full">
                        <Button.Basic
                            onClick={submitForm}
                            disabled={false}
                            icon={null}
                            loading={false}
                            type="primary"
                            size='medium'
                            text='Submit'
                            className='btn-primary'
                        />
                    </div>
                </div>
            )}
        </React.Fragment>
    )
}

export default AddReviewResponse